// Search for "Specialaftale" to find specialaftale-stuff
import angular from "angular";
import { result } from "lodash";

import "../../services/product";
import "./products-list-item";
import "../../services/datastorage";
import "../../services/media";
import "../../services/cart";
import events from "../../services/events";
import timer from "../../services/timer";

class ProductState {
    constructor() {
        this.page = 1;
        this.totalItems = 0;
        this.totalPages = 0;
    }
}

class SearchFilter {
    constructor({ siteId, areaId }) {
        (this.siteId = siteId),
            (this.areaId = areaId),
            (this.categoryIds = []),
            (this.query = ""),
            (this.events = null),
            (this.weekdays = []),
            (this.orderBy = 0),
            (this.keyAccountOnly = true),
            (this.fewAvailable = 0),
            (this.oneTimeEvent = 0);
    }
}

class SortOption {
    constructor({ label, orderId }) {
        this.label = label;
        this.orderId = orderId;
    }
}

angular.module("folkeuni").component("productsList", {
    bindings: {
        categoryUrl: "@",
        currentProgramUrl: "@",
        filterHeadline: "@",
        categoryPickerLabel: "@",
        timePickerLabel: "@",
        filterText: "@",
        siteId: "<",
        siteName: "@",
        areaId: "<",
        filterOnly: "<",
        programUrl: "@",
        isFestival: "<"
    },
    templateUrl: "/shop-dist/templates/products-list.html?c=" + window.cacheBurst,
    transclude: true,
    controller: function (DataStorage, Media, Product, $window, Cart, $document, $element, $timeout, $rootScope) {
        const $ctrl = Object.assign(this, {
            categoryPickerText: "Hvilken type indhold søger du?",
            timePickerText: "Hvornår har du tid?",
            products: [],
            categories: [],
            weekdays: Product.weekdaysArray,
            filterOnly: this.filterOnly ? this.filterOnly : false,
            preSelectedCategory: null,
            currentPage: 1,
            overlayer: null,
            hideProductList: false,
            productCount: 0,
            lastSearched: "",
            activeOptionNode: null,
            showRelevance: false,
            currentFilter: "",
            timeFunc: new timer(),
            loadDelay: 200,
            loading: true,
            fetching: false,
            productsState: new ProductState(),
            searchFilter: new SearchFilter({
                siteId: this.siteId,
                areaId: this.areaId
            }),
            sortingMap: [
                new SortOption({ label: "Dato", orderId: 0 }),
                new SortOption({ label: "Alfabetisk", orderId: 1 }),
                new SortOption({ label: "Relevans", orderId: 2 })
            ],
            pageSize: 25
        });
        $ctrl.getSelectedCategoriesString = function () {
            return $ctrl.categories
                .filter(function (item) {
                    return $ctrl.searchFilter.categoryIds.includes(item.id);
                })
                .map(function (item) {
                    return item.name[0].toUpperCase() + item.name.substring(1).toLowerCase();
                })
                .join(", ");
        };

        $ctrl.getSelectedWeekdaysString = function () {
            var selectedWeekdays = $ctrl.weekdays
                .filter(function (item) {
                    return item.active;
                })
                .map(function (item) {
                    return item.weekday;
                })
                .join(", ");

            if ($ctrl.searchFilter.oneTimeEvent == 1) {
                if (selectedWeekdays == "") selectedWeekdays += "Enkelt aften";
                else {
                    selectedWeekdays += ", Enkelt aften";
                }
            }

            return selectedWeekdays;
        };

        // Filter action handler
        $ctrl.handleFilterMenu = function (event) {
            $ctrl.activeOptionNode = event.target.parentNode;
            if ($ctrl.activeOptionNode.classList.contains("open")) {
                $ctrl.closeFilterMenu();
            } else {
                $ctrl.openFilterMenu();
            }
        };

        $ctrl.closeFilterMenu = function () {
            $ctrl.activeOptionNode.classList.remove("open");
            $ctrl.activeOptionNode.style.width = null;
            $ctrl.toggleFilterOverlayer();
        };

        $ctrl.openFilterMenu = function () {
            $ctrl.toggleFilterOverlayer();
            $ctrl.activeOptionNode.style.width = $ctrl.activeOptionNode.offsetWidth + "px";
            $ctrl.activeOptionNode.classList.add("open");

            if ($ctrl.overlayer !== null) {
                $ctrl.overlayer.addEventListener("click", $ctrl.closeFilterMenu);
            }
        };

        $ctrl.voucherReset = function () {
            Cart.reset();
            $ctrl.voucher = null;
            sessionStorage.removeItem("voucherSeen");
            $ctrl.filterChanged();
        };

        $ctrl.showVoucher = function () {
            if ($ctrl.voucher) {
                events.createModal({
                    headline: $ctrl.voucher.name2,
                    content: $ctrl.voucherContent()
                });
                sessionStorage.setItem("voucherSeen", "true");
            }
        };

        $ctrl.toggleKeyAccount = function () {
            $ctrl.searchFilter.keyAccountOnly = !$ctrl.searchFilter.keyAccountOnly;
            $ctrl.filterChanged();
        };

        $ctrl.voucherContent = function () {
            let output = [`<p>${$ctrl.voucher.description}</p>`];
            output = output.concat(
                $ctrl.voucher.areas.map((area) => {
                    return `
              <a class="btn outlined" href="/${area.url}/program">
                Se hold fra ${area.name}
              </a>
              `;
                })
            );

            return output.join("");
        };

        $ctrl.resetAll = function () {
            $ctrl.searchReset();
            $ctrl.weekdaysReset();
            $ctrl.resetSelectedCategories();
        };

        $ctrl.handleSubmit = function () {
            if ($ctrl.programUrl) {
                window.location.href = $ctrl.programUrl + ($ctrl.currentSearchUrl ? $ctrl.currentSearchUrl : "");
            } else {
                $ctrl.filterChanged();
            }
        };

        $ctrl.toggleFilterOverlayer = function () {
            if ($ctrl.overlayer === null) {
                $ctrl.overlayer = document.createElement("div");
                $ctrl.overlayer.classList.add("overlayer");
                document.body.appendChild($ctrl.overlayer);
            } else {
                $ctrl.overlayer.classList.add("fadeAway");
                setTimeout(function () {
                    $ctrl.overlayer.remove();
                    $ctrl.overlayer = null;
                }, 400);
            }
        };

        // Voucher state change
        $ctrl.voucherUpdate = function () {
            $ctrl.filterChanged();
            $rootScope.$broadcast("updateKeyAccount", $ctrl.searchFilter);
        };

        // Week Filter Handlers
        $ctrl.weekdaysUpdate = function (weekdayToUpdate) {
            if ($ctrl.searchFilter.weekdays.includes(weekdayToUpdate)) {
                $ctrl.searchFilter.weekdays.splice($ctrl.searchFilter.weekdays.indexOf(weekdayToUpdate), 1);
            } else {
                $ctrl.searchFilter.weekdays.push(weekdayToUpdate);
            }

            $ctrl.weekdaysFormat();
            $ctrl.filterChanged();
        };

        $ctrl.weekdaysReset = function () {
            Product.searchFilterWeekdaysReset($ctrl.searchFilter, $ctrl.weekdays).then(
                function (UpdatedObj) {
                    $ctrl.searchFilter.weekdays = [];
                    $ctrl.searchFilter.oneTimeEvent = 0;
                    $ctrl.weekdays = UpdatedObj.weekdays;
                    $ctrl.filterChanged();
                },
                function (errorResponse) {}
            );
        };

        $ctrl.weekdaysFormat = function () {
            $ctrl.weekdays = $ctrl.weekdays.map((entry) => {
                entry.active = $ctrl.searchFilter.weekdays.includes(entry.value);
                return entry;
            });
        };

        // Department filter handlers
        $ctrl.departmentUpdate = function (siteId) {
            $ctrl.searchFilter.siteId = Number($ctrl.siteId);
            $ctrl.searchFilter.areaId = Number(siteId);
            $ctrl.filterChanged();
        };

        // Categories Filter Handlers
        $ctrl.toggleSelectedCategories = function (id) {
            if (!$ctrl.searchFilter.categoryIds.includes(id)) {
                $ctrl.searchFilter.categoryIds.push(id);
            } else {
                $ctrl.searchFilter.categoryIds = $ctrl.searchFilter.categoryIds.filter(function (item) {
                    return item !== id;
                });
            }
            $ctrl.filterChanged();
        };

        $ctrl.resetSelectedCategories = function () {
            $ctrl.searchFilter.categoryIds = [];
            $ctrl.filterChanged();
        };

        // Search Filter Handlers
        $ctrl.searchReturnHandler = function (event) {
            if (event.keyCode == 13 && $ctrl.searchFilter.query.length > 0) {
                // Quickfix to wait for currentSearchUrl to be updated
                setTimeout(() => {
                    $ctrl.handleSubmit();
                }, 250);
            }
        };

        $ctrl.searchUpdated = function () {
            $ctrl.updateUrlParams();
            clearTimeout(window.queryTimeout);
            if (
                ($ctrl.searchFilter.query && $ctrl.searchFilter.query.length > 3) ||
                $ctrl.searchFilter.query.length == 0
            ) {
                window.queryTimeout = setTimeout(function () {
                    $ctrl.filterChanged();
                }, 750);
            }
        };

        $ctrl.searchReset = function () {
            if ($ctrl.searchFilter.query != "") {
                $ctrl.searchFilter.query = "";
                $ctrl.filterChanged();
            }
        };

        // Order by
        $ctrl.orderBySet = function (orderBy) {
            $ctrl.searchFilter.orderBy = orderBy;
            $ctrl.filterChanged();
        };

        $ctrl.showFewAvailable = function () {
            $ctrl.searchFilter.fewAvailable = +!$ctrl.searchFilter.fewAvailable;
            $ctrl.filterChanged();
        };

        $ctrl.showOneTimeEvents = function () {
            $ctrl.searchFilter.oneTimeEvent = +!$ctrl.searchFilter.oneTimeEvent;
            $ctrl.filterChanged();
        };

        $ctrl.$onInit = async () => {
            window.addEventListener("pageshow", (e) => {
                if (e.persisted) {
                    $ctrl.$onInit();
                }
            });
            if (window.location.href.indexOf("voucher=1") != -1) {
                $ctrl.searchFilter.keyAccountOnly = true;
            }
            if ("scrollRestoration" in history) {
                history.scrollRestoration = "manual";
            }
            $ctrl.categoryPickerText = $ctrl.categoryPickerLabel ? $ctrl.categoryPickerLabel : $ctrl.categoryPickerText;
            $ctrl.timePickerText = $ctrl.timePickerLabel ? $ctrl.timePickerLabel : $ctrl.timePickerText;

            const { weekdays, categoryIds, query, lastSearched, orderBy, currentPage, fewAvailable, oneTimeEvents } =
                await initParameters();
            $ctrl.searchFilter.weekdays = weekdays;
            $ctrl.searchFilter.categoryIds = categoryIds;
            $ctrl.searchFilter.query = query;
            $ctrl.searchFilter.orderBy = orderBy;
            $ctrl.searchFilter.areaId = $ctrl.areaId;
            $ctrl.searchFilter.siteId = $ctrl.siteId;
            $ctrl.searchFilter.fewAvailable = fewAvailable;
            $ctrl.searchFilter.oneTimeEvent = oneTimeEvents;
            $ctrl.lastSearched = lastSearched;
            $ctrl.currentPage = currentPage;

            await Product.getKeyAccountContract().then(
                function (contractObj) {
                    const voucherSeen = sessionStorage.getItem("voucherSeen");
                    $ctrl.voucher = contractObj;

                    if ($ctrl.voucher) {
                        $ctrl.voucher.startFormatted = window.formatDates($ctrl.voucher.registrationStart);
                        $ctrl.voucher.endFormatted = $ctrl.voucher.endFormatted
                            ? window.formatDates($ctrl.voucher.registrationEnd)
                            : false;

                        if (!voucherSeen) {
                            $ctrl.showVoucher();
                        }
                    }
                },
                function (errorResponse) {
                    $ctrl.searchFilter.keyAccountOnly = false;
                }
            );

            const { activeWeekdays, categories, products: productsData } = await initProducts();
            if (productsData) {
                const { products, productsState, showRelevance } = productsData;
                $ctrl.productsState = productsState;
                $ctrl.products = products;
                $ctrl.showRelevance = showRelevance;
            }

            $ctrl.categories = categories;
            $ctrl.activeWeekdays = activeWeekdays;
            $ctrl.loading = false;
            document.addEventListener("scroll", $ctrl.loadMoreHandler, true);
            $rootScope.$apply();
            goToLastVisitedProduct();

            function initParameters() {
                return new Promise((resolve) => {
                    const getPerameters = new URL(window.location.href).searchParams;
                    const searchQuery = getPerameters.get("query") ? getPerameters.get("query") : "";
                    let orderByParam = getPerameters.get("orderBy");
                    if (orderByParam) {
                        orderByParam = parseInt(orderByParam);
                    } else {
                        // For query search then default to relevance
                        orderByParam = searchQuery.length ? 2 : 0;
                    }
                    
                    resolve({
                        weekdays: getPerameters.get("weekdays")
                            ? getPerameters
                                  .get("weekdays")
                                  .split(",")
                                  .map((item) => parseInt(item))
                            : [],
                        categoryIds: getPerameters.get("categoryIds")
                            ? getPerameters
                                  .get("categoryIds")
                                  .split(",")
                                  .map((item) => parseInt(item))
                            : [],
                        query: searchQuery,
                        lastSearched: searchQuery,
                        orderBy: orderByParam,
                        currentPage: getPerameters.get("page") ? parseInt(getPerameters.get("page")) : 1,
                        oneTimeEvents: getPerameters.get("oneTimeEvents")
                            ? parseInt(getPerameters.get("oneTimeEvents"))
                            : 0,
                        fewAvailable: getPerameters.get("fewAvailable")
                            ? parseInt(getPerameters.get("fewAvailable"))
                            : 0
                    });
                });
            }

            function initProducts() {
                $ctrl.loading = true;
                const areaObj = {
                    siteId: $ctrl.siteId,
                    areaId: $ctrl.areaId,
                    keyAccountOnly: $ctrl.searchFilter.keyAccountOnly
                };

                return new Promise(async (resolve, reject) => {
                    const output = {};

                    const categories = await Product.getProductCategoriesByArea(areaObj);
                    output.categories = categories;

                    const activeWeekdays = await Product.getActiveWeekdays(areaObj);
                    output.activeWeekdays = activeWeekdays;
                    output.weekdays = $ctrl.weekdaysFormat(
                        $ctrl.searchFilter.weekdays.filter((entry) => output.activeWeekdays.includes(entry))
                    );

                    if ($ctrl.currentPage > 1) {
                        output.products = await $ctrl.fetchProductInfo({
                            searchObj: $ctrl.searchFilter,
                            urlExt: "?page=1&pageSize=" + $ctrl.pageSize * $ctrl.currentPage + "&crop=48:25"
                        });
                    } else {
                        output.products = await $ctrl.fetchProductInfo();
                    }

                    resolve(output);
                });
            }

            function goToLastVisitedProduct() {
                if (typeof Storage !== "undefined") {
                    DataStorage.get("lastVisitedProduct").then(
                        function (lastVisitedProductIndex) {
                            var productInArray = $ctrl.products.filter((item) => {
                                return item.id == lastVisitedProductIndex;
                            });

                            if (productInArray.length > 0) {
                                const findTarget = setInterval(() => {
                                    const elm = document.querySelector(
                                        `.product-card[data-productid="${productInArray[0].id}"]`
                                    );
                                    if (elm != null) {
                                        elm.scrollIntoView({
                                            behavior: "smooth",
                                            block: "center"
                                        });
                                        clearInterval(findTarget);
                                    }
                                }, 100);
                            } else {
                                $window.scrollTo(0, 0);
                            }

                            DataStorage.set("lastVisitedProduct", "");
                        },
                        function (message) {}
                    );
                }
            }
        };

        $ctrl.switchedToQuery = () => {
            if ($ctrl.lastSearched.length == 0 && $ctrl.searchFilter.query.length > 0) {
                return 2;
            } else if ($ctrl.searchFilter.orderBy == 2 && $ctrl.searchFilter.query.length == 0) {
                return 0;
            }
            return $ctrl.searchFilter.orderBy;
        };

        $ctrl.filterChanged = async function () {
            const filterStringed = JSON.stringify($ctrl.searchFilter);
            const isFilterChanged = $ctrl.currentFilter != filterStringed;
            $ctrl.currentFilter = filterStringed;

            if (isFilterChanged) {
                $ctrl.loadDelay = 1000;
                $ctrl.searchFilter.orderBy = $ctrl.switchedToQuery();
                $ctrl.lastSearched = $ctrl.searchFilter.query;
                $ctrl.loading = true;
                $ctrl.currentPage = 1;
                $ctrl.updateUrlParams();
                const productsData = await $ctrl.fetchProductInfo();
                if (productsData) {
                    const { products, productsState, showRelevance } = productsData;
                    $ctrl.productsState = productsState;
                    $ctrl.products = products;
                    $ctrl.showRelevance = showRelevance;
                }
                $ctrl.loading = false;
                $rootScope.$apply();
            }
        };

        $ctrl.getMoreProducts = async (newIndex) => {
            const currentLoadedItems = $ctrl.currentPage * $ctrl.pageSize;
            if ($ctrl.productsState.totalItems > currentLoadedItems) {
                $ctrl.fetching = true;
                $ctrl.currentPage = newIndex;
                $ctrl.updateUrlParams();
                const productsData = await $ctrl.fetchProductInfo();
                if (productsData) {
                    const { products, productsState, showRelevance } = productsData;
                    $ctrl.productsState = productsState;
                    $ctrl.products = $ctrl.products.concat(products);
                    $ctrl.showRelevance = showRelevance;
                }
                $ctrl.fetching = false;
                $rootScope.$apply();
            }
        };

        $ctrl.loadMoreHandler = () => {
            const currentTriggerDistance = document.body.scrollHeight - window.innerHeight * 2;
            if (window.scrollY >= currentTriggerDistance && $ctrl.fetching == false) {
                $ctrl.getMoreProducts($ctrl.currentPage + 1);
            }
        };

        $ctrl.updateUrlParams = function () {
            const allowedEntries = ["categoryIds", "weekdays", "query", "orderBy"];

            const searchParams = new URL(location.href).searchParams;

            allowedEntries.forEach((entry) => {
                let output = $ctrl.searchFilter[entry];
                if (Array.isArray(output)) {
                    output = output.filter((entry) => entry).join(",");
                }
                if (output !== '') {
                    searchParams.set(entry, output.toString());
                } else {
                    searchParams.delete(entry);
                }
            });

            searchParams.set("page", $ctrl.currentPage);
            if ($ctrl.searchFilter.fewAvailable == 1) {
                searchParams.set("fewAvailable", $ctrl.searchFilter.fewAvailable);
            }
            if ($ctrl.searchFilter.oneTimeEvent == 1) {
                searchParams.set("oneTimeEvents", $ctrl.searchFilter.oneTimeEvent);
            }

            history.replaceState && history.replaceState(null, "", location.pathname + "?" + searchParams.toString());
        };

        $ctrl.fetchProductInfo = (params) => {
            if (!$ctrl.filterOnly) {
                return $ctrl.getProducts(params);
            } else {
                return $ctrl.getProductsCount();
            }
        };

        $ctrl.getProductsCount = () => {
            Product.getProductsByCategoryCount($ctrl.searchFilter).then((result) => {
                $ctrl.productCount = result;
            });
            $ctrl.loading = false;
        };

        $ctrl.getProducts = async (params) => {
            const output = {
                showRelevance: $ctrl.searchFilter.query.length > 0,
                products: $ctrl.products || [],
                productsState: {}
            };

            const parameters = params
                ? params
                : { searchObj: $ctrl.searchFilter, urlExt: $ctrl.getDefaultProductNav() };

            if ($ctrl.searchFilter.query.length <= 3 && $ctrl.searchFilter.query.length >= 1) {
                $ctrl.searchFilter.query = "";

                events.createToast({
                    stays: true,
                    message: "Fritekst søgning kræver minimum 3 tegn"
                });
            }

            return new Promise((resolve) => {
                $ctrl.timeFunc.debounce(async function () {
                    output.products = await fetchProducts();
                    $ctrl.loadDelay = 200;
                    resolve(output);
                }, $ctrl.loadDelay)();
            });

            function fetchProducts() {
                return new Promise(async function (resolve, reject) {
                    const productsData = await Product.getProductsByCategory({...parameters, fewAvailable: 0});

                    output.productsState = {
                        page: productsData.page,
                        totalItems: productsData.totalItems,
                        totalPages: productsData.totalPages
                    };

                    $ctrl.productCount = output.productsState.totalItems;

                    resolve(productsData.items);
                });
            }
        };

        $ctrl.getDefaultProductNav = () => {
            return "?page=" + $ctrl.currentPage + "&pageSize=" + $ctrl.pageSize + "&crop=48:25";
        };

        $ctrl.categoryNameFormatter = (name) => {
            if ($ctrl.siteId == 15) {
                return name;
            }
            return name[0].toUpperCase() + name.substring(1).toLowerCase();
        };
    }
});
